import { Button, Col, Input, Row, DatePicker, message } from 'antd';
import { Form, Formik } from 'formik';
import moment from 'moment';
import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import Item from '../../../components/Form/Item';
import DivisionForm from '../DivisionForm';
import axios from '../../../util/Api';

const { RangePicker } = DatePicker;

const Index = ({ project }) => {
  const history = useHistory();
  return (
    <Formik
      initialValues={{
        name: project.name,
        division: project.division.id,
        code: project.code,
        manager: project.manager,
        phone: project.phone,
        email: project.email,
        date: [moment(project.start_date), moment(project.end_date)]
      }}
      onSubmit={values => {
        const start = values.date[0].format("YYYY-MM-DD");
        const end = values.date[1].format("YYYY-MM-DD");
        const url = `/project/update?id=${project.id}`;
        const data = { ...values, start: start, end: end };
        axios.post(url, data).then(({ data }) => {
          if (data.success) {
            message.success("Perubahan proyek telah berhasil disimpan",5);
            history.push(`/project/detail?id=${project.id}`);
          } else {
            message.error("Gagal menyimpan data proyek baru");
          }
        }).catch(err => {
          const resp = err.response;
          message.error(resp);
        });
      }}
    >
      {(formik) => {
        return (
          <Form>
            <Item name="Nama Proyek">
              <Input name="name" value={formik.values.name} onChange={formik.handleChange} />
            </Item>
            <Item name="Divisi Operasi">
              <DivisionForm />
            </Item>
            <Item name="Kode Proyek">
              <Input name="code" value={formik.values.code} onChange={formik.handleChange} />
            </Item>
            <Item name="PM / Manajer Proyek">
              <Input name="manager" value={formik.values.manager} onChange={formik.handleChange} />
            </Item>
            <Item name="Email">
              <Input name="email" value={formik.values.email} onChange={formik.handleChange} />
            </Item>
            <Item name="Phone/WA Admin Proyek">
              <Input name="phone" value={formik.values.phone} onChange={formik.handleChange} />
            </Item>
            <Item name="Mulai - Berakhir">
              <RangePicker defaultValue={formik.values.date} format="DD MMMM YYYY" onChange={(date) => {
                formik.setFieldValue("date", date);
              }}/>
            </Item>
            <Row>
              <Col span={6}></Col>
              <Col span={18}>
                <Button type="primary" htmlType="submit" className="gx-mb-0" loading={formik.isSubmitting}>
                  Simpan Perubahan
                </Button>
                <Link to={`/project/detail?id=${project.id}`} className="ant-btn ant-btn-secondary gx-mb-0">
                  Kembali
                </Link>
              </Col>
            </Row>
          </Form>
        );
      }}
    </Formik>
  );
}

export default Index;